import { render, staticRenderFns } from "./DisplayLoopingData.vue?vue&type=template&id=a1a356d8"
import script from "./DisplayLoopingData.vue?vue&type=script&lang=ts"
export * from "./DisplayLoopingData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports